/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package core.domain

open class ApiException(message: String) : Exception(message = message)